import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { isSSR } from '../helpers';
import { apiGetUserData } from './api';
import { BP_ID_COOKIE_NAME, QUERY_KEY_USER_DATA } from './constants';
import { UserData } from './model';
import { getIsUserAuthorized } from './utils';

const userDataQueryFn = async (): Promise<UserData | null> => {
    const userData = (await apiGetUserData()).data;

    return userData?.status === 'success' ? userData.data : null;
};

type UserDataParams = { isEnabled: boolean };

export const useUserDataQueryBase = ({ isEnabled }: UserDataParams) => {
    const { isLoading, data } = useQuery<UserData | null>({
        queryKey: [QUERY_KEY_USER_DATA],
        queryFn: () => (getIsUserAuthorized() ? userDataQueryFn() : null),
        enabled: isEnabled,
        initialData: (!isSSR() && window.TC?.sso?.userData) || (isEnabled && !getIsUserAuthorized() ? null : undefined),
        gcTime: 0,
    });

    useEffect(() => {
        if (data?.id) {
            Cookies.set(BP_ID_COOKIE_NAME, data?.id, { path: '/' });
        }
    }, [data?.id]);

    return { isLoadingUserData: isLoading, userData: data };
};

export const useUserData = () => useUserDataQueryBase({ isEnabled: !isSSR() });
